// TODO: BE `sendupsellemail` only whitelists `communicate`; once it accepts `announcements`, rename the key and drop this alias
export const UPSELL_TYPE_ALIASES = {
  announcements: 'communicate',
}

export const getUpsellData = (t) => ({
  rewards: {
    title: t('upselling:data.rewards.title'),
    preTitleText: t('upselling:data.rewards.preTitleText'),
    description: t('upselling:data.rewards.description'),
    textToRender: () => {
      const items = t('upselling:data.rewards.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <h3>{t('upselling:data.rewards.intro')}</h3>
          <ol>
            {items.map((item, index) => (
              <li key={index}>
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ol>
        </div>
      )
    },
    image: '/images/upselling/gift-card.png',
  },
  loyalty: {
    title: t('upselling:data.loyalty.title'),
    preTitleText: t('upselling:data.loyalty.preTitleText'),
    description: t('upselling:data.loyalty.description'),
    textToRender: () => {
      const items = t('upselling:data.loyalty.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <h3>{t('upselling:data.loyalty.intro')}</h3>
          <ol>
            {items.map((item, index) => (
              <li key={index}>
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ol>
        </div>
      )
    },
    image: '/images/upselling/gift-card.png',
  },
  giftCards: {
    title: t('upselling:data.giftCards.title'),
    preTitleText: t('upselling:data.giftCards.preTitleText'),
    description: t('upselling:data.giftCards.description'),
    textToRender: () => {
      const items = t('upselling:data.giftCards.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <h3>{t('upselling:data.giftCards.intro')}</h3>
          <ol>
            {items.map((item, index) => (
              <li key={index}>
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ol>
        </div>
      )
    },
    image: '/images/upselling/gift-card.png',
  },
  communicate: {
    title: t('upselling:data.communicate.title'),
    preTitleText: t('upselling:data.communicate.preTitleText'),
    description: t('upselling:data.communicate.description'),
    textToRender: () => {
      const items = t('upselling:data.communicate.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/communication-tool.png',
  },
  unifiedInbox: {
    title: t('upselling:data.unifiedInbox.title'),
    preTitleText: t('upselling:data.unifiedInbox.preTitleText'),
    description: t('upselling:data.unifiedInbox.description'),
    textToRender: () => {
      const items = t('upselling:data.unifiedInbox.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/unified-inbox.png',
  },
  groups: {
    title: t('upselling:data.groups.title'),
    preTitleText: t('upselling:data.groups.preTitleText'),
    description: t('upselling:data.groups.description'),
    textToRender: () => {
      const items = t('upselling:data.groups.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/groups.png',
  },
  checklists: {
    title: t('upselling:data.checklists.title'),
    preTitleText: t('upselling:data.checklists.preTitleText'),
    description: t('upselling:data.checklists.description'),
    textToRender: () => {
      const items = t('upselling:data.checklists.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/checklists.png',
  },
  amenityReservations: {
    title: t('upselling:data.amenityReservations.title'),
    preTitleText: t('upselling:data.amenityReservations.preTitleText'),
    description: t('upselling:data.amenityReservations.description'),
    textToRender: () => {
      const items = t('upselling:data.amenityReservations.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/amenity-reservations.png',
  },
  maintenance: {
    title: t('upselling:data.maintenance.title'),
    preTitleText: t('upselling:data.maintenance.preTitleText'),
    description: t('upselling:data.maintenance.description'),
    textToRender: () => {
      const items = t('upselling:data.maintenance.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/maintenance.png',
  },
  visitorManagement: {
    title: t('upselling:data.visitorManagement.title'),
    preTitleText: t('upselling:data.visitorManagement.preTitleText'),
    description: t('upselling:data.visitorManagement.description'),
    textToRender: () => {
      const items = t('upselling:data.visitorManagement.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/visitor-management.png',
  },
  packageManagement: {
    title: t('upselling:data.packageManagement.title'),
    preTitleText: t('upselling:data.packageManagement.preTitleText'),
    description: t('upselling:data.packageManagement.description'),
    textToRender: () => {
      const items = t('upselling:data.packageManagement.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/package-management.png',
  },
  buildingEssentials: {
    title: t('upselling:data.buildingEssentials.title'),
    preTitleText: t('upselling:data.buildingEssentials.preTitleText'),
    description: t('upselling:data.buildingEssentials.description'),
    textToRender: () => {
      const items = t('upselling:data.buildingEssentials.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/building-essentials.png',
  },
  reputationManagement: {
    title: t('upselling:data.reputationManagement.title'),
    preTitleText: t('upselling:data.reputationManagement.preTitleText'),
    description: t('upselling:data.reputationManagement.description'),
    textToRender: () => {
      const items = t('upselling:data.reputationManagement.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/reputation-management.png',
  },
  digitalSignage: {
    title: t('upselling:data.digitalSignage.title'),
    preTitleText: t('upselling:data.digitalSignage.preTitleText'),
    description: t('upselling:data.digitalSignage.description'),
    textToRender: () => {
      const items = t('upselling:data.digitalSignage.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/digital-signage.png',
  },
  parking: {
    title: t('upselling:data.parking.title'),
    preTitleText: t('upselling:data.parking.preTitleText'),
    description: t('upselling:data.parking.description'),
    textToRender: () => {
      const items = t('upselling:data.parking.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/parking.png',
  },
  internalInspections: {
    title: t('upselling:data.internalInspections.title'),
    preTitleText: t('upselling:data.internalInspections.preTitleText'),
    description: t('upselling:data.internalInspections.description'),
    textToRender: () => {
      const items = t('upselling:data.internalInspections.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/parking.png',
  },
  parkingManagement: {
    title: t('upselling:data.parkingManagement.title'),
    preTitleText: t('upselling:data.parkingManagement.preTitleText'),
    description: t('upselling:data.parkingManagement.description'),
    textToRender: () => {
      const items = t('upselling:data.parkingManagement.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <h3>{t('upselling:data.parkingManagement.intro')}</h3>
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/parking-management.png',
    videoUrl: 'https://redvike-chefs.s3.us-east-1.amazonaws.com/ParkingManagementUpsell.mp4',
  },
  marketShopManagement: {
    title: t('upselling:data.marketShopManagement.title'),
    preTitleText: t('upselling:data.marketShopManagement.preTitleText'),
    description: t('upselling:data.marketShopManagement.description'),
    textToRender: () => {
      const items = t('upselling:data.marketShopManagement.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/market-shop.png',
    videoUrl: 'https://redvike-chefs.s3.us-east-1.amazonaws.com/Marketshop.mp4',
  },
  residentEvents: {
    title: t('upselling:data.residentEvents.title'),
    preTitleText: t('upselling:data.residentEvents.preTitleText'),
    description: t('upselling:data.residentEvents.description'),
    textToRender: () => {
      const items = t('upselling:data.residentEvents.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/resident-events.png',
    videoUrl:
      'https://redvike-chefs.s3.us-east-1.amazonaws.com/ElevateOS_+Resident+Event+Marketplace.mp4',
  },
  incidentReports: {
    title: t('upselling:data.incidentReports.title'),
    preTitleText: t('upselling:data.incidentReports.preTitleText'),
    description: t('upselling:data.incidentReports.description'),
    textToRender: () => {
      const items = t('upselling:data.incidentReports.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/incident-reports.png',
    videoUrl:
      'https://redvike-chefs.s3.us-east-1.amazonaws.com/Introducing+the+New+Incident+Reports+Module+for+Property+Management.mp4',
  },
  assetTracking: {
    title: t('upselling:data.assetTracking.title'),
    preTitleText: t('upselling:data.assetTracking.preTitleText'),
    description: t('upselling:data.assetTracking.description'),
    textToRender: () => {
      const items = t('upselling:data.assetTracking.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/asset-tracking.png',
    videoUrl:
      'https://redvike-chefs.s3.us-east-1.amazonaws.com/Introducing+the+New+Assets+and+Inventory+Tracker+Module.mp4',
  },
  frontDesk: {
    title: t('upselling:data.frontDesk.title'),
    preTitleText: t('upselling:data.frontDesk.preTitleText'),
    description: t('upselling:data.frontDesk.description'),
    textToRender: () => {
      const items = t('upselling:data.frontDesk.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/front-desk.png',
    videoUrl:
      'https://redvike-chefs.s3.us-east-1.amazonaws.com/Introducing+Our+New+Front+Desk+Management+System!+(BETA).mp4',
  },
  restaurantManager: {
    title: t('upselling:data.restaurantManager.title'),
    preTitleText: t('upselling:data.restaurantManager.preTitleText'),
    description: t('upselling:data.restaurantManager.description'),
    textToRender: () => {
      const items = t('upselling:data.restaurantManager.items', { returnObjects: true })
      return (
        <div className="ctp-upselling__container__main-content__dynamic-content">
          <ul>
            {items.map((item, index) => (
              <li key={index} className="dotted">
                <b>{item.heading}</b> {item.body}
              </li>
            ))}
          </ul>
        </div>
      )
    },
    image: '/images/upselling/restaurant-management.png',
  },
})
